export const requestUrl =
  process.env.NODE_ENV === 'production'
    ? ''
    : process.env.NODE_ENV === 'dev'
    ? ''
    : 'http://localhost:9091';

export const ossUrl = 'https://yl.oss.jdbsk.com';
